// extracted by mini-css-extract-plugin
export default {"lastblog":"styles_lastblog__W9DO2","detail__cover":"styles_detail__cover__oWbAO","detail__desc":"styles_detail__desc__fQLLn"};